<style lang="less">
.daUsers {
  width: 7rem;
  margin: 0 auto;
  padding: 0.2rem 0;
  .k-col {
    padding: 0.08rem 0;
  }
  .k-col--x1 {
    margin-left: 4%;
  }
  .k-col--x2 {
    margin-left: 2%;
  }
}
.daBrothers {
  .daUserItem {
    position: relative;
    top: 0;
    left: 0;
  }
}
</style>
<template>
  <div v-if="isLeader" class="daUsers">
    <k-row>
      <k-col
        v-for="(group, index) in groups"
        :key="index"
        span="4"
        :class="`k-col--x${index % 5 ? 2 : 1}`"
      >
        <da-user-group class="daUserGroup--pin" :group="group"
      /></k-col>
    </k-row>
  </div>
  <div v-else-if="inviteGroups[0]" class="daBrothers">
    <da-user-group class="daUserGroup--x3" :group="groups[0]" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import daUserGroup from './da-user-group'
export default {
  components: {
    daUserGroup
  },
  computed: {
    ...mapGetters('laxin/da', ['inviteGroups', 'isLeader']),
    groups() {
      const { inviteGroups } = this
      const length = Math.max(10, inviteGroups.length)
      const A = []
      for (let i = 0; i < length; i++) {
        A.push(inviteGroups[i] || [])
      }
      return A
    }
  }
}
</script>
